import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { ScrollAdapterComponent } from '@frontend/sports/common/core/feature/scroll-adapter';
import { ThemeInverse } from '@frontend/sports/common/ui/shared';
import { SportsThemedPillsDirective } from '@frontend/sports/common/ui/sports-themed-pills';
import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';
import { DsPill } from '@frontend/ui/pill';
import { MediaQueryService } from '@frontend/vanilla/core';
import { Observable, distinctUntilChanged, map } from 'rxjs';

import { ScrollSelectedInViewDirective } from '../../directives/scroll-selected-in-view/scroll-selected-in-view.directive';
import { TabBarItem } from '../../tab-bar/tab-bar.models';

@Component({
    selector: 'ms-fixture-list-menu',
    templateUrl: './fixture-list-menu.component.html',
    styleUrls: ['./fixture-list-menu.component.scss'],
    imports: [DsPill, ScrollAdapterComponent, CommonModule, ScrollSelectedInViewDirective, SportsThemedPillsDirective],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FixtureListMenuComponent implements OnInit, OnChanges {
    @Input() pills: TabBarItem[];
    fixturePills = signal<TabBarItem[]>([]);
    mediaQuery$: Observable<boolean>;
    themeInverseIndicator: ThemeInverse;

    constructor(
        private redirectHelper: RedirectHelperService,
        private mediaQueryService: MediaQueryService,
    ) {
        this.mediaQuery$ = this.mediaQueryService.observe().pipe(
            map(() => this.mediaQueryService.isActive('lt-md')),
            distinctUntilChanged(),
        );
        const mediaQuery = toSignal(this.mediaQuery$, { requireSync: true });
        this.themeInverseIndicator = mediaQuery()
            ? {
                  'mgm-4': { isInverse: true },
              }
            : {};
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.fixturePills.set(changes.pills.currentValue);
    }

    ngOnInit(): void {
        this.fixturePills.set(this.pills);
    }

    get active(): TabBarItem | undefined {
        return (
            this.fixturePills() &&
            this.fixturePills()
                .filter((pill) => pill.active)
                .pop()
        );
    }

    eventSelected(pillsItem: TabBarItem): void {
        this.fixturePills.update((pill) =>
            pill.map((item) => ({
                ...item,
                active: item.id === pillsItem.id,
            })),
        );
        const pillItem = this.fixturePills().find((pill) => pill.id === pillsItem.id);
        this.redirectHelper.goToPage(pillItem?.url);
    }
}
